/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// React
import React from 'react';
import {
	ActionIcon,
	ActionIconProps,
} from '@mantine/core';
import { JSX } from 'react/jsx-runtime';

// Icons
import { IconX } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                    Type                                    */
/* -------------------------------------------------------------------------- */

type ResetButtonProps = JSX.IntrinsicAttributes &
	ActionIconProps & {
		component?: 'button' | undefined;
	} & Omit<
		Omit<
			React.DetailedHTMLProps<
				React.ButtonHTMLAttributes<HTMLButtonElement>,
				HTMLButtonElement
			>,
			'ref'
		>,
		'component' | keyof ActionIconProps
	> & {
		ref?:
			| ((instance: HTMLButtonElement | null) => void)
			| React.RefObject<HTMLButtonElement>
			| null
			| undefined;
	};

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const ResetButton = (props: ResetButtonProps) => {
	return (
		<ActionIcon {...props}>
			<IconX size={16} />
		</ActionIcon>
	);
};
